"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _KeyIcon = require("./KeyIcon");

var _KeyIcon2 = _interopRequireDefault(_KeyIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _KeyIcon2.default;